<template>
	<!-- v-if="isHumanReview" -->
	<div class="newExamFace">
		<div class="faceBack"></div>
		<div class="faceDataDlo">
			<div class="titleDialog"></div>
			<div class="faceDiv">
				<div class="faceData">
					<div class="leftTop"></div>
					<div class="rightTop"></div>
					<div class="leftButton"></div>
					<div class="rightButton"></div>
					<i class="faceDataLine"></i>
					<!--  -->

					<video v-if="isFaceVideo" autoplay playsinline id="video" width="100%" height="200"></video>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
// import HumanReview from "@/components/humanReview";
require('tracking/build/tracking-min.js');
require('tracking/build/data/face-min.js');
import { putObjectBlob } from '@/utils/upload';
import { getUpExamLog } from '@/api/exam';

export default {
	name: 'newExamFace',
	// components: { HumanReview },
	props: {
		isFaceVideo: {
			type: Boolean,
			default: true
		},
		dataText: {
			type: Object,
			default: () => {},
		},
	},
	data() {
		return {
			// start: true,
			isSuccessful: '',
			// isHumanReview: true,
			routerPath: '',
			mediaStreamTrack: null,
			setCaptureTime: '',
			exam_plan: null,
			info: null
		};
	},
	watch: {
		dataText: {
			handler(v) {
				this.getDataFace(v);
			},
			deep: true,
		},
	},
	destroyed() {
		clearInterval(this.setCaptureTime);
	},
	mounted() {
		this.openCameraFz();
		this.routerPath = this.$route.path;
	},
	methods: {
		openCameraFz() {
			this.openUserMedia();
		},
		getDataFace(data) {
			this.exam_plan = data.exam_plan;
			this.info = data.info;
			this.setTimeNum();
		},
		setTimeNum() {
			let capture = this.exam_plan.capture;
			if (capture != 0) {
				//开启定时抓拍
				this.setCaptureTime = setInterval(() => {
					if (this.isFaceVideo) {
						this.upCapture(1);
					} else {
						this.$emit('upCaptures');
					}
				}, capture * 60000);
			}
		},
		upCapture(type) {
			console.log(111);
			let video = document.getElementById('video');
			let canvas = document.createElement('canvas');
			canvas.width = video.videoWidth;
			canvas.height = video.videoHeight;
			canvas.getContext('2d').drawImage(video, 0, 0, canvas.width, canvas.height);

			canvas.getContext('2d').drawImage(video, 0, 0, 300, 250);
			const imgData = canvas.toDataURL('image/png');
			let file = this.dataURLtoFile(imgData, 'image/png');
			putObjectBlob(file, res => {
				let data = {
					make_id: this.info.id,
					content: res,
					type: type
				};
				getUpExamLog(data).then(item => {});
			});
		},
		dataURLtoFile(dataURI, type) {
			let binary = atob(dataURI.split(',')[1]);
			let array = [];
			for (let i = 0; i < binary.length; i++) {
				array.push(binary.charCodeAt(i));
			}
			return new Blob([new Uint8Array(array)], { type: type });
		},
		openUserMedia() {
			if (navigator.mediaDevices.getUserMedia || navigator.webkitGetUserMedia || navigator.mozGetUserMedia || navigator.getUserMedia) {
				this.getUserMediaToPhoto(
					{
						video: {
							width: 300,
							height: 250,
							facingMode: 'user'
						}
					},
					this.success,
					this.error
				);
			} else {
				alert('你的浏览器不支持访问用户媒体设备');
			}
		},

		getUserMediaToPhoto(constraints, success, error) {
			if (navigator.mediaDevices.getUserMedia) {
				navigator.mediaDevices
					.getUserMedia(constraints)
					.then(success)
					.catch(error);
			} else if (navigator.webkitGetUserMedia) {
				navigator.webkitGetUserMedia(constraints, success, error);
			} else if (navigator.mozGetUserMedia) {
				navigator.mozGetUserMedia(constraints, success, error);
			} else if (navigator.getUserMedia) {
				navigator.getUserMedia(constraints, success, error);
			}
		},
		success(stream) {
			const than = this;
			let video = document.getElementById('video');
			than.mediaStreamTrack = null;
			than.mediaStreamTrack = stream;
			try {
				video.srcObject = stream;
			} catch (e) {
				console.log('访问用户媒体设备失败：', e.name, e.message);
			}
			video.play(); //播放视频
		},
		error(error) {
			this.isSuccessful = 'equipment';
			console.log('访问用户媒体失败：', error.name, error.message);
		}
	}
};
</script>

<style scoped lang="scss">
.faceDiv {
	display: flex;
	flex-direction: column;
	align-items: center;
}
.faceDiv .faceData {
	width: 100%;
	overflow: hidden;
	position: relative;
}
.faceDiv .faceData .faceNumber {
	width: 100%;
	height: 250px;
	background: rgba(0, 0, 0, 0.3);
	position: absolute;
	left: 0;
	top: 0;
	display: flex;
	justify-content: center;
	align-items: center;
	font-size: 80px;
	font-weight: bold;
	color: #fff;
}
.faceDiv .leftTop {
	width: 50px;
	height: 50px;
	border-left: 10px solid #2e58ff;
	border-top: 10px solid #2e58ff;
	position: absolute;
	left: 0;
	top: 0;
}
.faceDiv .rightTop {
	width: 50px;
	height: 50px;
	border-right: 10px solid #2e58ff;
	border-top: 10px solid #2e58ff;
	position: absolute;
	right: 0;
	top: 0;
}
.faceDiv .leftButton {
	width: 50px;
	height: 50px;
	border-left: 10px solid #2e58ff;
	border-bottom: 10px solid #2e58ff;
	position: absolute;
	left: 0;
	bottom: 0;
}
.faceDiv .rightButton {
	width: 50px;
	height: 50px;
	border-right: 10px solid #2e58ff;
	border-bottom: 10px solid #2e58ff;
	position: absolute;
	right: 0;
	bottom: 0;
}
.faceDiv .faceDataLine {
	width: 100%;
	height: 2px;
	background: #2e58ff;
	position: absolute;
	top: 0;
	animation: keyLine 1.5s infinite;
}
.faceDivSuccessful {
	display: flex;
	flex-direction: column;
	align-items: center;
}
.faceDivSuccessful strong {
	margin-bottom: 20px;
	font-size: 15px;
	color: #333;
}
.faceDivSuccessful p {
	font-size: 14px;
	color: #999;
}
.faceDivSuccessful .pButton {
	margin: 5px 0 30px;
}
.faceDivSuccessful img {
	margin: 75px 0 25px;
}
.faceDivSuccessful .auditImg {
	margin: 150px 0 25px;
}
.refer-btn {
	width: 233px;
	border-radius: 50px;
	margin-top: 20px;
}
.isReturn:hover {
	opacity: 0.7;
}
.detIcon {
	font-size: 30px;
	position: absolute;
	top: 10px;
	right: 10px;
	cursor: pointer;
}
.detIcon:hover {
	color: #2e58ff;
}
@keyframes keyLine {
	0% {
		top: 0;
	}
	50% {
		top: 250px;
	}
	100% {
		top: 0;
	}
}
</style>
